import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { HCRProvider } from "contexts/hcr.context";

const App = React.lazy(() => import(/* webpackChunkName: "App" */ "./App"));

const Main = () => {
  return (
    <Provider store={configureStore}>
      <Suspense fallback={<div className="loading" />}>
        <BrowserRouter>
          <HCRProvider>
            <App />
          </HCRProvider>
        </BrowserRouter>
      </Suspense>
    </Provider>
  );
};

ReactDOM.render(<Main />, document.getElementById("root"));
reportWebVitals();
